import React from "react";
import SettingsComponent from "../components/settings/SettingsComponent";

const SettingsContainer = () => {
  return <SettingsComponent />;
};

export default SettingsContainer;
